import { trackOnOverlay, removeOverlayTrack } from "./animation";
import schema from "./schema/index";
import { mapUnderlay } from "./render";
import { setFocus } from "./render/effects";

let currentOverlayTracker = null;
let currentTarget = null;
let currentCrosshair = null;
let currentUnderlay = null;
let locked = false;
let targetSet = null;
let targetUpdated = null;

export function setTargetHandlers(setHandler, updatedHandler) {
  targetSet = setHandler;
  targetUpdated = updatedHandler;
}

// Published for effects that key off the selection, hovered as well as locked:
// the depth of field is how you find what you are pointing at, so making it wait
// for a click means having to click to find out whether the thing under the
// pointer was the one you wanted.
const focus = { x: 0, y: 0, r: 0 };

function trackingUpdated(overlay, x, y, bounds, xs, ys) {
  if (!currentCrosshair) {
    // Both are decoration drawn over and under whatever is being pointed at, so
    // neither may be hit: the halo in particular covers the very node that put it
    // there, and picking it instead loses the target on the next mouse move —
    // which took the reticle out again a frame after it appeared.
    currentCrosshair = overlay
      .append("circle")
      .attr("fill", "none")
      .attr("pointer-events", "none")
      .attr("stroke-dasharray", "12 5");
    currentUnderlay = mapUnderlay()
      .append("circle")
      .attr("stroke", "none")
      .attr("pointer-events", "none")
      .attr("fill", "#f2f2f2");
  }

  const top = y < bounds.y2 * 0.75 + bounds.y1 * 0.25;
  if (top != currentTarget.isTop) {
    currentTarget.isTop = top;
    targetUpdated && targetUpdated(currentTarget);
  }

  const radiusProp = schema.objectTypes[currentTarget.type].layout.radius;
  const radius =
    radiusProp instanceof Function ? radiusProp(currentTarget) : radiusProp;
  const r = radius * xs + (locked ? 10 : 13);

  focus.x = x;
  focus.y = y;
  focus.r = r;
  setFocus(focus);

  currentCrosshair
    .attr("r", r)
    .attr("cx", x)
    .attr("cy", y)
    .attr("opacity", locked ? 1 : 0.5)
    .attr("stroke", locked ? "#f57f25" : "navy")
    .attr("stroke-width", locked ? 3 : 2);
  currentUnderlay
    .attr("r", r)
    .attr("cx", x)
    .attr("cy", y)
    .attr("opacity", locked ? 1 : 0.7);
}

function targetRemoved() {
  setTargetInternal(null, false);
}

function setTargetInternal(target, isLocked) {
  if (currentOverlayTracker) {
    removeOverlayTrack(currentOverlayTracker);
    currentOverlayTracker = null;
  }
  currentTarget = target;
  targetSet && targetSet(target);
  // The recorded position belongs to whatever was being tracked, so it stops
  // meaning anything the moment that changes.
  setFocus(null);
  if (target == null) {
    if (currentCrosshair != null) {
      currentCrosshair.remove();
      currentCrosshair = null;
      currentUnderlay.remove();
      currentUnderlay = null;
    }
    return;
  }
  currentOverlayTracker = trackOnOverlay(
    target.elem,
    trackingUpdated,
    targetRemoved,
    target
  );
}

export function browseTarget(target) {
  if (locked) return;
  setTargetInternal(target, false);
}

export function lockTarget(target) {
  if (target == currentTarget && locked) {
    locked = false;
  } else {
    locked = target != null;
  }
  setTargetInternal(target, locked);
}
